import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pos-session-open',
  templateUrl: './pos-session-open.component.html',
  styleUrls: ['./pos-session-open.component.css']
})
export class PosSessionOpenComponent implements OnInit {

  cashier_name;

  model = {
    'table_name': 'pos_session', 'session_id': '0', 'session_no': '', 'start_time': '',
    'machine': this.applicationConstants.machine_no, 'cashier': this.applicationConstants.user_info.casher_acct_number,
    'cash_open': '', 'bank_open': '', 'coupon_open': '', 'reason': '', 'comment': ''
  };

  Success_Msg; Error_Msg; Cash_Msg; Bank_Msg; Coupon_Msg; Not_Counter_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants, private router: Router,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    this.cashier_name = (this.applicationConstants.user_lang == 'ar' ? this.applicationConstants.user_info['name'] : this.applicationConstants.user_info['name_en']);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Cash_Msg').subscribe((res: string) => {
      this.Cash_Msg = res;
    });

    translate.get('Bank_Msg').subscribe((res: string) => {
      this.Bank_Msg = res;
    });

    translate.get('Coupon_Msg').subscribe((res: string) => {
      this.Coupon_Msg = res;
    }); 

    translate.get('Not_Counter_Msg').subscribe((res: string) => {
      this.Not_Counter_Msg = res;
    });
  }


  ngOnInit() {
  }

  add() {
    if (this.applicationConstants.user_info['is_counter'] == '0') {
      alert(this.Not_Counter_Msg);
      return;
    }

    if (this.model['cash_open'] == '') {
      alert(this.Cash_Msg);
      return;
    }
      
    if (this.model['bank_open'] == '') {
      alert(this.Bank_Msg);
      return;
    }
      
    if (this.model['coupon_open'] == '') {
      alert(this.Coupon_Msg);
      return;
    }
      
    let today = new Date();
    this.model['start_time'] = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" +
      today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();

    let values = [];
    values.push(this.model);

    let obj;
    let prefix = this.model['machine'] + this.applicationConstants.user_info.casher_acct_number;
    obj = { cmd: 'add', values: values, pk: 'session_no', id: 'session_id', main_table: 'pos_session', 
      prefix: prefix };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.router.navigate(['sub_menu/1/sale_point']);
        }
        else {
          alert(this.Error_Msg);
        }
      });
    
  }

}
